import DaumPostcode from "react-daum-postcode"
import { Layer } from "components"

const Postcode = ({ show, setShow, getArredss }) => {
	

	const onCompletePost = (data) => {
		getArredss(data)
		setShow(false)
		/* let fullAddress = data.address
		let extraAddr = ""

		if (data.addressType === "R") {
			if (data.bname !== "") {
				extraAddr += data.bname
			}
			if (data.buildingName !== "") {
				extraAddr += extraAddr !== "" ? `, ${data.buildingName}` : data.buildingName
			}
			fullAddress += extraAddr !== "" ? ` (${extraAddr})` : ""
		} */

	}

	const postCodeStyle = {
		display: "block",
		position: "relative",
		top: "0%",
		width: "100%",
		height: "100%",
		padding: "7px",
	}

	return (
		<Layer show={show} closeLayer={() => setShow(false)} title="주소 검색">
			<DaumPostcode style={postCodeStyle} autoClose onComplete={onCompletePost} />
		</Layer>
	)
}

export default Postcode
